module.exports = __webpack_public_path__ + "img/45000.c6e1893d.jpg";